import React, { memo, useState, useCallback, useMemo } from 'react';
import {
    createUseStyles,
    Text,
    RadioGroup,
    Modal,
    Icon,
    Link,
    Multiplier,
    Loader,
    Advice,
} from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'UpdateOptions');

const UpdateOptions = ({
    idType,
    onChangeIdType,
    syncNames,
    onChangeSyncNames,
    fields,
    entityLabel,
}) => {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = useCallback(() => setIsModalOpen(true), []);

    const handleCloseModal = useCallback(() => setIsModalOpen(false), []);

    const onClick = useCallback((e) => e.stopPropagation(), []);

    const filteredFields = useMemo(
        () =>
            fields?.map((field) => ({
                ...field,
                isDisabled: syncNames
                    ?.map((el) => el?.field?.value || el?.value)
                    ?.includes(field?.value),
            })),
        [syncNames, fields],
    );

    const options = useMemo(
        () => [
            {
                label: t('cfm_label_id'),
                value: 'id',
                className: 'import-export__import-type--update-id--id',
            },
            {
                label: t('cmf_label_import_others'),
                value: 'others',
                className: 'import-export__import-type--update-id--other',
            },
        ],
        [t],
    );

    const schema = useMemo(
        () => ({
            name: 'field',
            type: 'select',
            labelMode: 'vertical',
            attrs: {
                options: filteredFields,
            },
        }),
        [filteredFields],
    );

    const modalClasses = useMemo(
        () => ({ header: classes.modalInfoHeader }),
        [classes.modalInfoHeader],
    );

    return (
        <div className={classes.chooseId} onClick={onClick}>
            <div className={classes.chooseIdLabelContainer}>
                <Icon className={classes.chooseIdLabelIconEdit} name="edit" />
                <Text type="subtitle">{t('cfm_label_import_identifier')} </Text>
                <Icon
                    name="info"
                    size="small"
                    className={classes.chooseIdLabelIcon}
                    onClick={handleOpenModal}
                />
            </div>
            <Advice className={classes.chooseIdAdvice} type="info" showIcon showCollapse={false}>
                {t('cfm_label_import_recommned_id', [
                    entityLabel,
                    entityLabel,
                    entityLabel,
                    entityLabel,
                ])}
            </Advice>
            <RadioGroup
                className={classes.radioGroup}
                labelMode="vertical"
                options={options}
                onChange={onChangeIdType}
                value={idType}
                orientation="horizontal"
            />
            {idType === 'others' && fields && (
                <Multiplier
                    name="syncNames"
                    className={classes.multiplier}
                    buttonLabel={t('cfm_action_add_field')}
                    buttonClassName={classes.multiplierAddButton}
                    value={syncNames || []}
                    schema={schema}
                    separator={false}
                    onChange={onChangeSyncNames}
                    labelMode="vertical"
                    isFullWidth
                />
            )}
            {idType === 'others' && !fields && (
                <div className={classes.multiplierLoader}>
                    <Loader />
                </div>
            )}
            <Modal
                classes={modalClasses}
                title={t('cfm_label_import_identifier')}
                isOpen={isModalOpen}
                useCornerClose={false}
                onConfirm={handleCloseModal}
                confirmText={t('cfm_action_done_2')}
            >
                <Text className={classes.modalInfoText}>
                    {t('cfm_label_import_identifier_Info_1')}
                </Text>
                <Text className={classes.modalInfoText}>
                    {t('cfm_label_import_identifier_Info_2')}
                </Text>
                <Text className={classes.modalInfoText}>
                    {t('cfm_label_import_identifier_Info_3')}
                </Text>
                <Link
                    className={classes.modalInfoLink}
                    href={t('cfm_label_import_identifier_more_info')}
                    target="_blank"
                >
                    {t('cfm_action_more_info')}
                </Link>
            </Modal>
        </div>
    );
};

UpdateOptions.propUpdateOptionss = {};

export default memo(UpdateOptions);
